import { ReactNode } from 'react';
import { useCrossTabSubscriptionSync } from '@/shared/hooks/useCrossTabSubscriptionSync';

interface CrossTabSyncProviderProps {
  children: ReactNode;
}

/**
 * CrossTabSyncProvider
 * Mounts the cross-tab sync hook at app level
 */
export function CrossTabSyncProvider({ children }: CrossTabSyncProviderProps) {
  useCrossTabSubscriptionSync();
  return <>{children}</>;
}
